import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {KpiValuesById} from '../types'
import {getSlaKpiValuesValidationSchema} from '../validators'

export const useSlaKpiValuesValidationSchema = (kpiValuesById: KpiValuesById) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const validationSchema = useMemo(() => {
    return getSlaKpiValuesValidationSchema(kpiValuesById, t)
  }, [kpiValuesById, t])

  return validationSchema
}
